export default __webpack_public_path__ + "static/media/1.d1b6159c.webp";